// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__xgkmV","left":"StickyBox_left__2pWXW","right":"StickyBox_right__EkaVG"};